import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthProviderCard, FormField, SetupAccordion } from '../components';
export function MicrosoftSAMLSection({ enabled, entityId, ssoUrl, certificate, emailAttribute, authServiceUrl, tenantSlug, onToggle, onEntityIdChange, onSsoUrlChange, onCertificateChange, onEmailAttributeChange }) {
    return /*#__PURE__*/ _jsxs(AuthProviderCard, {
        title: "Microsoft Azure AD SAML SSO",
        description: "Enterprise Azure Active Directory authentication via SAML 2.0",
        enabled: enabled,
        onToggle: onToggle,
        children: [
            /*#__PURE__*/ _jsx(SetupAccordion, {
                title: "📋 Guide me through setup",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 1: Create Azure AD Enterprise Application"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-2 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Sign in to the",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "https://portal.azure.com",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-blue-600 hover:underline",
                                                    children: "Azure Portal"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Navigate to ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Azure Active Directory → Enterprise applications"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "+ New application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "+ Create your own application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: 'Enter your app name (e.g., "Your App - SAML")'
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Select",
                                                ' ',
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: '"Integrate any other application you don\'t find in the gallery (Non-gallery)"'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Create"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 2: Configure SAML Single Sign-On"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-2 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "In your new Enterprise Application, go to ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Single sign-on"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Select ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "SAML"
                                                }),
                                                " as the single sign-on method"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Edit"
                                                }),
                                                ' on "Basic SAML Configuration" section'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 3: Configure Service Provider URLs in Azure"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "bg-white border rounded p-3 space-y-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "Identifier (Entity ID):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/microsoft/metadata"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "Reply URL (Assertion Consumer Service URL):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/microsoft/acs"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "Sign on URL (optional):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/microsoft/sso"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "text-xs text-gray-600 mt-2",
                                    children: [
                                        "Copy these URLs and paste them into the Basic SAML Configuration in Azure AD, then click ",
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "Save"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 4: Get Azure AD Configuration"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-gray-600 mb-2",
                                    children: "Two options to configure:"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-2 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Quick Setup (Recommended):"
                                                }),
                                                " Use the",
                                                ' ',
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Upload Metadata XML"
                                                }),
                                                " button above this section to automatically fill all fields."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Manual Setup:"
                                                }),
                                                " Copy values individually from Azure Portal:",
                                                /*#__PURE__*/ _jsxs("ul", {
                                                    className: "list-disc list-inside ml-4 mt-1 space-y-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Download ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Certificate (Base64)"
                                                                }),
                                                                ' and paste into "Certificate" field below'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Copy ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Login URL"
                                                                }),
                                                                ' and paste into "SSO URL" field below'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Copy ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Azure AD Identifier"
                                                                }),
                                                                ' and paste into "Entity ID" field below'
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 5: Configure User Attributes (Optional)"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: "Azure AD includes email claim by default. The default claim is:"
                                }),
                                /*#__PURE__*/ _jsx("code", {
                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all mt-1",
                                    children: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-xs text-gray-600 mt-2",
                                    children: "This is already configured below. Only change if you use a custom claim."
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 6: Assign Users"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-1 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Go to ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Users and groups"
                                                }),
                                                " in your Enterprise Application"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "+ Add user/group"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: "Select users or groups who should have access"
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Assign"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 7: Fill in Configuration Below"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        "Copy the values from Step 4 and paste them into the configuration fields below, then click ",
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "Save Changes"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-saml-entity-id",
                label: "Entity ID (Azure AD Identifier)",
                value: entityId,
                onChange: onEntityIdChange,
                placeholder: "https://sts.windows.net/your-tenant-id/",
                helpText: "Found in Azure Portal → Enterprise Applications → Single sign-on → Azure AD Identifier",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-saml-sso-url",
                label: "SSO URL (Login URL)",
                value: ssoUrl,
                onChange: onSsoUrlChange,
                placeholder: "https://login.microsoftonline.com/your-tenant-id/saml2",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-saml-certificate",
                label: "Certificate (X.509 Certificate)",
                value: certificate,
                onChange: onCertificateChange,
                rows: 6,
                placeholder: "-----BEGIN CERTIFICATE----- MIIDdDCCAlygAwIBAgIGAY... -----END CERTIFICATE-----",
                helpText: "Download Certificate (Base64) from Azure Portal (including BEGIN/END lines)",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-saml-email-attribute",
                label: "Email Attribute Name",
                value: emailAttribute || 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
                onChange: onEmailAttributeChange,
                placeholder: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
                helpText: "Default is the standard Microsoft email claim. Change only if using a custom claim."
            })
        ]
    });
}
